import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        const scrollTop = window.scrollY;

        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;

        const scrolledPercentage = scrollTop / scrollableHeight;

        if (scrolledPercentage > 0.2) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <Zoom in={isVisible}>
            <Fab
                color="primary"
                size="medium"
                onClick={scrollToTop}
                aria-label="scroll back to top"
                sx={styles.fab}
            >
                <KeyboardArrowUpIcon />
            </Fab>
        </Zoom>
    );
};

const styles = {
    fab: {
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 1000,

        backgroundColor: '#b31684',
        '&:hover': {
            backgroundColor: '#b31684',
        },
        '&:active': {
            backgroundColor: '#b31684',
        }
    }
};

export default ScrollToTop;
